import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';
import { NotifyService } from './shared/notify.service';

// import tablas
import { table } from '../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class SolpagService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
    public _notifyService: NotifyService
  ) { }
  // tslint:disable: prefer-const
  // Save nueva solicitud de pago
  saveSolpag(solpag) {
    let objStr = JSON.stringify(solpag);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.sopa}","objc":${objStr}}`)

    objStr = encodeURIComponent(objStr);
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.sopa}","objc":${objStr}}`)
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.sopa}","objc":${objStr}}`
    ).pipe(map
      ((res: any) => {
        return res;
      }));
  }

  // Actualiza solpag
  updateSolpagAtrb(prnt, obj) {
    let objStr = JSON.stringify(obj);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.sopa}","prnt":"${prnt}","objc":${objStr}}`);

    objStr = encodeURIComponent(objStr);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.sopa}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(
      map(
        (res: any) => {
          return res;
        }));
  }

  // Eliminar atributo de la Solpag, para actualizar. con objeto
  deleteSolpagAtrb(prnt, obj) {
    let objStr = JSON.stringify(obj);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    // console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.sopa}","prnt":"${prnt}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.sopa}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }

  // Consulta todas las solicitudes de pago para datatable
  getSolpags() {
    // console.log(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.sopa}"}`)
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.sopa}"}`)
      .pipe(map
        ((res: Response) => {
          let dataUser = { data: res };
          return dataUser;
        }));
  }

  // Consulta de SolPago por padre (prnt)
  public getSolpag(prnt, type) {
    let path;
    if (type === 'old') {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.sopaOldr}","type":"${table.type.metaExtn}","objc":{"prnt":"${prnt}"}}`;
    } else {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.sopa}","type":"${table.type.metaExtn}","objc":{"prnt":"${prnt}"}}`;
    }
    // return this.http.get('assets/data/pruebasolpag2.json'
    return this.http.get(path)
      .pipe(map
        (res => {
          return res;
        }));
  }

  getSolPagEspecifico(codigo, factura, oc) {
    let path;
    //path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"${atrb}":"${opt}"}}`
    path = this._apiRestService.APIURL.serv6 +
      `/{"tble":"${table.sopa}","objc":{"codigo":"${codigo}","factura":"${factura}","oc":"${oc}"}}`;

    return this.http.get(path)
      .pipe(map((res: Response) => {
        return res;
      })
      );
  }

  // Cerrar solicitud, envia a tabla old
  cerrarSolpag(prnt) {
    // console.log(this._apiRestService.APIURL.serv10 + `/{"tble":"${table.sopa}","prnt":"${prnt}","type":"${table.type.toOld}"}`);
    return this.http.get(this._apiRestService.APIURL.serv10 + `/{"tble":"${table.sopa}","prnt":"${prnt}","type":"${table.type.toOld}"}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }

  // Consulta de todos las solicitudes cerradas
  public getSolpagCerradas() {
    // return this.http.get('assets/data/pruebaoc.json') // return res si se va a probar
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.sopaOldr}"}`)
      .pipe(map
        ((res: Response) => {
          let dataUser = { data: res };
          return dataUser;
        }));
  }


  async sendSolpag(solpag, materia, contenido, expediente, prnt) {

    let data = { "materia": materia, "contenido": contenido, "expediente": expediente, "prnt": prnt, "solpag": solpag };

    const response = await fetch(this._apiRestService.APIURL.serv201, {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const message = `Ocurrio un errror: ${response.status}`;
      throw new Error(message);
    }

    const respuesta = await response.json();
    this._notifyService.notifySuccForm(respuesta.mensaje);
  };
  /*

(
    [estado] => ERROR
    [mensaje] => USTED NO TIENE EL EXPEDIENTE 33775 EN SU PODER EN ESTE MOMENTO.
)
(
    [estado] => OK
    [mensaje] => CHECKLIST DE PAGO INGRESADO EXITOSAMENTE
    [idDocumento] => 116806
    [idExpediente] => 38672
  */
  // FIN - export class SolpagService
  //srv 202
  revisarSolpag(oc, n_sop, anio = "") {
    return this.http.get(this._apiRestService.APIURL.serv202 + `/${oc}/${n_sop}/${anio}`)
      .pipe(map
        ((res: any) => {
          let data = res;
          return data;
        }));
  };

}

/*

Orden de compra: 721703-272-CM22


Solicitud de pago 651
llamada: https://stdag-desarrollo.agenciaeducacion.cl/srvc/202/721703-272-CM22/651
respuesta:
{
  "encontrado":"si"
  "mensaje": "solicitud de pago encontrada",
  "oc": "721703-272-CM22",
  "analista": "Myriam",
  "tipo_doc": "Factura",
  "folio": "300671",
  "emisor": "80.989.400-2",
  "f_pub": "2022-10-04 20:14",
  "f_emision": "2022-10-04",
  "monto_dcto": "$145.424",
  "monto_fact": "",
  "n_sop": "651",
  "fecha_sop": "11-10-2022",
  "proveedor": "AGENCIA DE VIAJES TURAVION SPA",
  "servicio": "Compra de pasajes aéreos Santiago - Castro - Santiago",
  "plazo_acep_reclamo": "2022-10-11 20:14",
  "plazo_despacho_sop": "2022-10-16",
  "estado_dte": "ACEPTADO",
  "estado_sop": "EN FIRMA",
  "observacion": ""
}


*/
